import styled from 'styled-components';

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 7px;
`;

export const FilterIcon = styled.img`
  width: 14px;
  height: 14px;
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid
    ${({ $isActive, $isOpen }) => ($isActive || $isOpen ? '#2563eb' : '#d4d8dd')};
  outline: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  background: ${({ $isActive, $isOpen }) => ($isActive || $isOpen ? '#e9effd' : '#fff')};
  color: ${({ $isActive, $isOpen }) => ($isActive || $isOpen ? '#2563eb' : '#555')};
  border-radius: 8px;
  transition: all 0.2s ease;
  width: fit-content;

  &:hover {
    background: ${({ $isActive, $isOpen }) => ($isActive || $isOpen ? '#dbe6fc' : '#f5f5f5')};
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 9999px;
  width: fit-content;
  gap: 8px;
`;

export const ToggleButton = styled.button`
  padding: 5px 12px;
  border: ${({ $active }) => ($active ? 'none' : '0.5px solid #D4D8DD')};
  outline: none;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  background: ${({ $active }) => ($active ? '#e9effd' : 'transparent')};
  color: ${({ $active }) => ($active ? '#2563eb' : '#555')};
  border-radius: 20px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.25);
  }

  @media (max-width: 320px) {
    padding: 4px 8px;
    font-size: 10px;
  }
`;
